class ObjectStorage {
    constructor() {
        this.data = {};
        this.setItem = this.setItem.bind(this);
        this.getItem = this.getItem.bind(this);
    }

    setItem(key, value) {
        this.data[key] = value;
    }

    getItem(key) {
        if (this.data[key]) {
            return this.data[key] || null;
        }
        return null;
    }
}
export default ObjectStorage;
